export { default } from './Col2TextPicture'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col2TextPicture/index.js